import Page from 'components/page/page'

export default Page
